import { StandardProps } from '../types';
import { createStandardAction } from 'typesafe-actions';

export const setStandardData =
  createStandardAction('STANDARD/SET_DATA')<StandardProps>();
